import React, { FC } from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { Loader } from '../../Loader'
import { IColumns, IDataItem } from '../TableSmall'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 300,
    margin: 0,
    marginTop: -10,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    paddingBottom: theme.spacing(4),
    '& tr': {
      height: '35px',
      '&:nth-child(odd)': {
        borderBottom: '1px solid rgba(233,236,239,0.38)',
      },
    },
    '& td': {
      fontSize: 16,
      color: theme.palette.primary.light,
      border: 'none',
      padding: '10px 16px',
      '&:first-of-type': {
        opacity: 0.72,
      },
    },
  },
  container: {
    maxHeight: '1000px',
  },
  pagination: {
    color: '#FFFFFF',
  },
  editIcon: {
    color: '#51e5a5',
  },
  infoIcon: {
    color: '#a8a9ac',
  },
  buttons: {
    width: 210,
  },
  notFound: {
    backgroundColor: 'transparent !important',
    '& td': {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
  },
}))

interface TableProps {
  columns: IColumns[]
  data: IDataItem[]
  loading?: boolean
}

export const TableSimple: FC<TableProps> = ({ columns, data, loading }) => {
  const classes = useStyles()

  return (
    <>
      {loading && <Loader />}

      <Paper className={classes.root}>
        <TableContainer>
          <Table aria-label="sticky table">
            <TableBody>
              {data && data.length > 0 ? (
                /* eslint-disable-next-line */
                data.map((row: any, idx) => {
                  return (
                    <TableRow hover role="checkbox" key={idx}>
                      {columns.map((column) => (
                        <TableCell key={column.id}>
                          {column.format && typeof row[column.id] === 'number'
                            ? column.format(row[column.id])
                            : row[column.id]}
                          {column.id === 'asset' && ':'}
                        </TableCell>
                      ))}
                    </TableRow>
                  )
                })
              ) : (
                <TableRow className={classes.notFound}>
                  <TableCell colSpan={columns.length} align={'center'}>
                    {!loading && 'No results found'}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  )
}
